module.exports = __webpack_public_path__ + "static/media/023-Cecile et Ramone.00a6d323.png";